import { Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import Investors from "./pages/Investors/Investors";

const App = () => {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Investors" element={<Investors />} />
      </Routes>
    </div>
  );
};

export default App;
